import { supabase } from './supabase';

const PUSH_FUNCTION_URL = `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/send-push-notification`;

async function getHeaders(includeAuth = true) {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'Apikey': import.meta.env.VITE_SUPABASE_ANON_KEY,
  };

  if (includeAuth) {
    const { data: { session } } = await supabase.auth.getSession();
    if (session?.access_token) {
      headers['Authorization'] = `Bearer ${session.access_token}`;
    }
  }

  return headers;
}

export async function registerDeviceToken(
  token: string,
  platform: 'ios' | 'android' | 'web',
  deviceName?: string,
  appVersion?: string
) {
  const headers = await getHeaders(true);
  const response = await fetch(PUSH_FUNCTION_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      action: 'register_token',
      token,
      platform,
      device_name: deviceName,
      app_version: appVersion,
    }),
  });
  return response.json();
}

export async function unregisterDeviceToken(token: string) {
  const headers = await getHeaders(true);
  const response = await fetch(PUSH_FUNCTION_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      action: 'unregister_token',
      token,
    }),
  });
  return response.json();
}

export async function sendPushNotification(params: {
  title: string;
  body: string;
  action_url?: string;
  target_type?: 'all' | 'single' | 'platform';
  target_value?: string;
}) {
  const headers = await getHeaders();
  const response = await fetch(PUSH_FUNCTION_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ action: 'send', ...params }),
  });
  return response.json();
}

export async function sendTestPushNotification(params: {
  title: string;
  body: string;
  action_url?: string;
  target_value: string;
}) {
  const headers = await getHeaders();
  const response = await fetch(PUSH_FUNCTION_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ action: 'send_test', ...params }),
  });
  return response.json();
}

export async function getPushStats() {
  const headers = await getHeaders();
  const response = await fetch(PUSH_FUNCTION_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ action: 'get_stats' }),
  });
  return response.json();
}

export async function setupPushTables() {
  const headers = await getHeaders();
  const response = await fetch(PUSH_FUNCTION_URL, {
    method: 'POST',
    headers,
    body: JSON.stringify({ action: 'setup_tables' }),
  });
  return response.json();
}
